import { BaseModel } from '@/api/base-model'
import { MigrationMapAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'

export class MigrationMap extends BaseModel<MigrationMap> {
    protected collectionName = MigrationMapAPI.collectionName

    constructor(
        public company: Company|string|null,
        public id: string,
        public pipelineMapping: object,
        public phaseMapping: object,
        public reasonMapping: object,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    static fromData(data: any): MigrationMap {
        if (data === null || typeof data === 'string' || data instanceof MigrationMap) {
            return data
        }

        return new MigrationMap(
            data.company ? Company.fromData(data.company) : null,
            data.id,
            data.pipelineMapping,
            data.phaseMapping,
            data.reasonMapping,
            data.createdAt,
            data.updatedAt,
        )
    }
}
